/**
 * SectionHeading — shared eyebrow + headline pattern for the new light
 * Summer Camps sections (Feb 2026 mockup).
 *
 * Visual language pulled from the mockup the owner shared:
 *   ─── EYEBROW (yellow dash + yellow uppercase label)
 *   Big Brand-Blue Heading. Yellow highlighter behind the accent phrase.
 *   Optional sub-copy in soft charcoal.
 *
 * Use `accent` for the phrase that should sit on the yellow highlighter
 * marker — it gets a slightly skewed yellow bar behind it.
 *
 *   <SectionHeading
 *     eyebrow="How camp works"
 *     title="Five disciplines."
 *     accent="One epic week."
 *     body="Every camper rotates through all five STEM pillars…"
 *   />
 */
export default function SectionHeading({
  eyebrow, title, accent, body, align = 'center',
}) {
  const isCenter = align === 'center';
  return (
    <div className={`${isCenter ? 'max-w-2xl mx-auto text-center' : 'max-w-2xl text-left'}`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 text-[11px] sm:text-xs uppercase tracking-widest font-extrabold text-rsc-yellow ${
            isCenter ? 'justify-center' : ''
          }`}
        >
          <span className="inline-block h-[3px] w-6 bg-rsc-yellow rounded-full" aria-hidden />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-rsc-brand-blue leading-[1.15]">
        {title}{' '}
        {accent && (
          <span className="relative inline-block">
            {/* Yellow highlighter marker — slightly skewed bar behind the
                accent phrase. Sits behind the text via z-index. */}
            <span
              aria-hidden
              className="absolute inset-x-[-4px] bottom-[6%] h-[40%] bg-rsc-yellow -skew-x-3 rounded-sm"
            />
            <span className="relative">{accent}</span>
          </span>
        )}
      </h2>
      {body && (
        <p className="mt-3 text-rsc-charcoal text-base leading-relaxed">
          {body}
        </p>
      )}
    </div>
  );
}
